import React, { useState, useEffect } from "react";
import Icon from "../../components/ui/icon";
import "../../assets/styles/pages/publishers/settings.css";
import AdminSideNav from "../../components/layout/adminSideNav";
import { useToast } from "../../context/toastContext";
import { useNavigate } from "react-router-dom";
import api from "../../services/apiClient";
import NotAuthorizedMessage from "../../components/feedback/notAuthorizedMessage";

const AdminSettingsPage = () => {
  const navigate = useNavigate();
  const showToast = useToast();
  const [isSideNavActive, setisSideNavActive] = useState(false);
  const [userInfo, setUserInfo] = useState(
    JSON.parse(localStorage.getItem("AdminInfo")) || {}
  );
  const [settings, setSettings] = useState(() => {
    const saved = localStorage.getItem("globalSettings");
    return saved ? JSON.parse(saved) : {};
  });
  const [loading, setLoading] = useState(null);
  const isNotAdminUser = userInfo.role && userInfo.role !== "admin";

  useEffect(() => {
    const token = localStorage.getItem("aToken");
    if (!token) {
      navigate("/auth/login");
      return;
    }

    api
      .get(`/api/admin/info`)
      .then((response) => {
        setUserInfo(response.data.data);
        localStorage.setItem("AdminInfo", JSON.stringify(response.data.data));
        if (response.data.data.role !== "admin") return;
        api
          .get(`/api/a/settings`)
          .then((response) => {
            setSettings(response.data.settings);
            localStorage.setItem(
              "globalSettings",
              JSON.stringify(response.data.settings)
            );
          })
          .catch((err) => {
            showToast({
              status: "error",
              message: err.response?.data?.message || "Login not found.",
            });
          });
      })
      .catch((err) => {
        showToast({
          status: "error",
          message: err.response?.data?.message || "Login not found.",
        });
        navigate("/auth/login");
      });
  }, [navigate, showToast]);

  const toggleSetting = async (settingKey) => {
    if (isNotAdminUser) return;
    if (loading) return;

    const newValue = !settings[settingKey];
    setLoading(settingKey);

    try {
      const response = await api.put("/api/a/settings", {
        settingKey,
        value: newValue,
      });

      if (response.status === 200) {
        setSettings((prevSettings) => ({
          ...prevSettings,
          [settingKey]: newValue,
        }));
        localStorage.setItem(
          "globalSettings",
          JSON.stringify(response.data.settings)
        );
      }
    } catch (error) {
      showToast({
        status: "error",
        message: error.response?.data?.message || "Unable to Update!",
      });
    } finally {
      setLoading(null);
    }
  };

  return (
    <div className="settings__page">
      <AdminSideNav
        userName={userInfo.name}
        emailID={userInfo.email}
        active={isSideNavActive}
      />
      <div
        onClick={() => setisSideNavActive(!isSideNavActive)}
        className={
          isSideNavActive ? "background-shadow active" : "background-shadow"
        }
      ></div>
      <main>
        <header className="desktop-header">
          <div>
            <h2>Settings</h2>
            <p>Mange your account basic controls from here.</p>
          </div>
        </header>

        <header className="mobile-header">
          <div>
            <h2>Settings</h2>
          </div>
          <button
            className="nav-btn"
            onClick={() => setisSideNavActive(!isSideNavActive)}
          >
            {isSideNavActive ? (
              <Icon name="XMark" className="onLeft" />
            ) : (
              <Icon name="Bars3" className="onLeft" />
            )}
          </button>
        </header>

        {userInfo && userInfo.role !== "admin" && (
          <NotAuthorizedMessage />
        )}

        <div className="main-container">
          <div className="controls-container admin">
            <h2>App Controls</h2>
            <div className="divider"></div>
            <div className="control">
              <div className="text-info">
                <span>Auto Approve(P)</span>
                <p>New publishers will be approved automatically.</p>
              </div>
              <div
                className={`toggle-switch ${settings.AccAutoApproval ? "on" : ""
                  } ${loading === "AccAutoApproval" ? "changing" : ""}`}
                onClick={() => toggleSetting("AccAutoApproval")}
              >
                <div className="inner-circle"></div>
              </div>
            </div>
            <div className="control">
              <div className="text-info">
                <span>Accept New Convs</span>
                <p>New convs will be allowed.</p>
              </div>
              <div
                className={`toggle-switch ${settings.AcceptNewConvs ? "on" : ""
                  } ${loading === "AcceptNewConvs" ? "changing" : ""}`}
                onClick={() => toggleSetting("AcceptNewConvs")}
              >
                <div className="inner-circle"></div>
              </div>
            </div>
            <div className="control">
              <div className="text-info">
                <span>IP Security</span>
                <p>Only wishlisted ip can hit postback.</p>
              </div>
              <div
                className={`toggle-switch ${settings.IPSecurity ? "on" : ""} ${loading === "IPSecurity" ? "changing" : ""
                  }`}
                onClick={() => toggleSetting("IPSecurity")}
              >
                <div className="inner-circle"></div>
              </div>
            </div>
            <div className="control">
              <div className="text-info">
                <span>Logging Mode</span>
                <p>For developer to log activities</p>
              </div>
              <div
                className={`toggle-switch ${settings.LoggingMode ? "on" : ""} ${loading === "LoggingMode" ? "changing" : ""
                  }`}
                onClick={() => toggleSetting("LoggingMode")}
              >
                <div className="inner-circle"></div>
              </div>
            </div>
            <div className="control">
              <div className="text-info">
                <span>Hosting Clicks</span>
                <p>Allow/Deny clicks from hostings/servers.</p>
              </div>
              <div
                className={`toggle-switch ${settings.hostingClicks ? "on" : ""} ${loading === "hostingClicks" ? "changing" : ""
                  }`}
                onClick={() => toggleSetting("hostingClicks")}
              >
                <div className="inner-circle"></div>
              </div>
            </div>
            <div className="control">
              <div className="text-info">
                <span>Test Link</span>
                <p>Allow/Deny test link redirect even after first conversion.</p>
              </div>
              <div
                className={`toggle-switch ${settings.testLink ? "on" : ""} ${loading === "testLink" ? "changing" : ""
                  }`}
                onClick={() => toggleSetting("testLink")}
              >
                <div className="inner-circle"></div>
              </div>
            </div>
          </div>
        </div>

        <span className="copyright-text">
          © 2025 Swift Digital Ads, All rights reserved
        </span>
      </main>
    </div>
  );
};

export default AdminSettingsPage;
